import React from 'react';
import { Table, Row, Col, Pagination } from 'antd';

import { getParamTable, _tableLogActivity, _fmtRupiah } from '../../../../../lib/Helper';

class Desktop extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    };
  }

  componentDidMount() {
    this.props.fetchTable()
  }

  render() {
    const { table } = this.props.state
    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  width: '2%',
                },
                {
                  title: 'Tanggal',
                  dataIndex: 'tgl_transaksi',
                },
                {
                  title: 'Debet/Kredit',
                  dataIndex: 'tipe',
                },
                {
                  title: 'Nominal',
                  render: (a, row) => "Rp. " + (row.nominal ? _fmtRupiah(row.nominal) : "-")
                },
                {
                  title: 'Saldo',
                  render: (a, row) => "Rp. " + (row.saldo ? _fmtRupiah(row.saldo) : "-")
                },
                {
                  title: 'Keterangan',
                  dataIndex: 'keterangan',
                },
                {
                  title: 'LogActivity',
                  key: 'operation',
                  width: '10%',
                  render: (a, row) => _tableLogActivity(row),
                },
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

export default Desktop;
